<template>
  <div>
    <b-dropdown v-if="!activeUser" id="roundDropDown" text="Choose a round">
      <b-dropdown-item v-for="(round, index) in peerReviewRounds" :key="round.id" :value="round.id" @click="selectedRound = round.id">
        {{ `Round ${index + 1}` }}
      </b-dropdown-item>
    </b-dropdown>
    <professor-view-team-member-selection
      v-show="!activeUser"
      :round-id="parseInt(selectedRound)"
      @userSelected="setActiveUser($event)"
    ></professor-view-team-member-selection>
    <professor-view-review-of-member
      v-if="activeUser"
      :user-id="activeUser"
      :selected-round="selectedRound"
      :member-name="activeUserName"
      @deselectedUser="activeUser = ''"
    ></professor-view-review-of-member>
  </div>
</template>

<script>
import mapGettersMixin from '../../../mixins/mapGettersMixin'
import axios from '../../../../axios'
import ProfessorViewReviewOfMember from './ProfessorViewReviewOfMember.vue'
import ProfessorViewTeamMemberSelection from './ProfessorViewTeamMemberSelection.vue'

export default {
  components: { ProfessorViewTeamMemberSelection, ProfessorViewReviewOfMember },
  mixins: [mapGettersMixin],
  data() {
    return {
      peerReviewRounds: [],
      activeUser: '',
      selectedRound: null,
      selectedRoundText: 'Choose a round',
      activeUserName: ''
    }
  },
  created() {
    this.fetchPeerReviewRounds()
    this.$root.$on('peer-review-reset', this.resetView)
  },

  beforeDestroy() {
    this.$root.$off('peer-review-reset', this.resetView)
  },
  methods: {
    async fetchPeerReviewRounds() {
      /* In order  to get only the relevant rounds of a project it is necessary to supply the term and module id. We are getting those arguments via the project */
      const responseProjectId = await this.getProjectId
      const projectId = responseProjectId
      const response = await axios.get(`projects/${projectId}`)
      const termId = response.data.term.termId
      const moduleId = response.data.module.id
      const params = {
        params: {
          term_id: termId,
          module_id: moduleId
        }
      }
      const responseReviewRounds = await axios.get('peer-review-rounds/', params)
      const reviewRounds = responseReviewRounds.data
      this.peerReviewRounds = reviewRounds
    },

    selectRound(roundId, roundNumber) {
      this.selectedRound = roundId
      this.selectedRoundText = `Round ${roundNumber}`
    },

    setActiveUser({ userId, memberName }) {
      this.activeUser = userId
      this.activeUserName = memberName
    },

    resetView() {
      this.selectedRound = null
      this.activeUser = ''
      this.activeUserName = ''
    }
  }
}
</script>

<style scoped>
#roundDropDown {
  width: fit-content;
  margin-bottom: 10px;
}
</style>
